import React, { useCallback } from 'react'
import { Alert } from 'components'
import { useAlert } from 'components/Alerts/hooks'
import { alerts as alertKeys } from 'keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteAssessmentFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import { queryClient as qc } from 'keys'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { deleteTicketFetch, deleteTicketMessageFetch } from 'store/middlewares/tickets.crud'

const RemoveTicketMessageAlert = () => {
    const { alerts } = useSelector(state => state.general)
    const { setAlerts } = useAlert()
    const queryClient = useQueryClient()

    const { mutateAsync: deleteTicketMessage } = useMutation({
        mutationFn: deleteTicketMessageFetch,
        onSuccess: () => {
            handleClose()
            queryClient.invalidateQueries([qc.ticketMessages])
        },
        onError: () => {
            handleClose()
            toast.error("בעייה במחיקה", toastConfig)
        }
    })

    const handleClose = useCallback(() => {
        setAlerts(alertKeys.removeTicketMessage, false)
    }, [])

    const removeTicketMessage = useCallback(() => {
        deleteTicketMessage(alerts.removeTicketMessage.props)
    }, [])

    const footerActions = React.useMemo(
        () => [
            { label: "ביטול", color: "thirdly4", action: handleClose },
            { label: "מחיקה", color: "error", action: removeTicketMessage }
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={" האם את בטוחה שאת רוצה למחוק את ההודעה?"}
            footerActions={footerActions}
            handleAlert={handleClose}
        >
            {"מחיקת ההודעה תמחק את ההודעה לצמיתות"}
        </Alert>
    )
}

export default RemoveTicketMessageAlert